import React, { useMemo } from 'react';
import { getAdditionalProps } from '../utils';
export var getTdProps = getAdditionalProps('dm-table__cell dm-table__cell--body auto-table-cell-body', function (state, rowInfo, column) {
  return {
    'data-label': column.label,
    width: column.width
  };
});
export default function BaseCell(_ref) {
  var className = _ref.className,
    children = _ref.children,
    label = _ref['data-label'],
    width = _ref.width;
  var style = useMemo(function () {
    return width ? {
      width: width
    } : undefined;
  }, [width]);
  return /*#__PURE__*/React.createElement("div", {
    role: "gridcell",
    className: className,
    "data-label": label,
    style: style
  }, children);
}